/***
 * Instead of using [T, T, T].includes(value) (that lacks type checking) we can use this function in
 * order to make sure the array is a subset of the value.
 */
export const includes = <T extends U, U>(arr: readonly T[], searchElement: U): searchElement is T =>
  arr.includes(searchElement as T);
